import { useQuery } from "@tanstack/react-query";
import { useHttp } from "./useHttp";

export function useTQuery(key, url, method = "get", requestBody = null, enabled = true, staleTime = 0, callback, pathParams, appendQueryParams) {
  // console.log(`key, url,requestBody, enabled,`, key, url, requestBody, enabled,);

  const api = useHttp({});
  return useQuery({
    queryKey: key,
    queryFn: async () => {
      if (!url) {
        return null; // Safeguard for missing URLs
      }
      return api[method](`${url}`, requestBody).then((res) => {
        if (callback) {
          callback(res.data);
        }
        return res.data;
      });
    },
    onError: (e) => {
      console.error("API Error:", e);
    },
    staleTime: staleTime ?? 1000 * 60 * 5, // Cache results for 5 minutes
    enabled, // Use 'enabled' state for controlling when to fetch data
    refetchOnWindowFocus: true,
  });
}
